<highcharts-chart
  [Highcharts]="Highcharts"
  [options]="chartOptions"
  [style]="chartStyle"
  (chartInstance)="saveInstance($event)"
></highcharts-chart>
